import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  remittanceReceiptFailed: {
    defaultMessage:
      'Document is processing, please wait for a few seconds and try again. If problem persists, please open the form from the Reconciliation Report.',
    description: 'Failed to download PDF of remittance receipt'
  },
  docDownloadFailed: {
    defaultMessage: 'Document not found',
    description: 'Failed to download PDF of remittance receipt'
  }
});
